/* Erozin PDP runtime. State = selected pack + purchase type. Buy box, sticky bar and final CTA all submit the one form #ero-form.
   One /cart/add.js call carries the pack (with its selling plan when subscribing) plus the gifts the pack unlocks. */
(function () {
  if (window.__ero) return;
  window.__ero = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function init() {
    var buy = $('[data-ero-buy]');
    var form = $('#ero-form');
    if (!buy || !form) return;
    var packs = $$('input[type="radio"][name="id"]', form);
    var modes = $$('input[name="ero_mode"]', form);
    var planInput = $('[data-ero-plan-input]', form);
    var gifts = $$('[data-ero-gift]', buy);
    var ctaPrice = $$('[data-ero-cta-price]');
    var btns = $$('[data-ero-cta]');
    var vrow = $('[data-ero-value]', buy);
    var cur = /USD\s*$/.test(buy.getAttribute('data-money') || '') ? 'USD' : '';
    var fmt = function (c) { var v = c / 100; try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: (Math.round(v * 100) % 100 ? 2 : 0), maximumFractionDigits: 2 }).format(v); } catch (e) { return ''; } };

    function selected() { return packs.filter(function (p) { return p.checked; })[0] || packs[0]; }
    function mode() { var m = modes.filter(function (x) { return x.checked; })[0]; return m ? m.value : 'once'; }

    function sync() {
      var p = selected(); if (!p) return;
      var m = mode();
      var idx = parseInt(p.getAttribute('data-idx'), 10) || 1;
      buy.setAttribute('data-mode', m);
      buy.setAttribute('data-pack', idx);
      var plan = p.getAttribute('data-plan');
      if (m === 'sub' && plan) { planInput.value = plan; planInput.disabled = false; } else { planInput.value = ''; planInput.disabled = true; }
      var price = m === 'sub' && p.getAttribute('data-sub') ? p.getAttribute('data-sub') : p.getAttribute('data-once');
      ctaPrice.forEach(function (n) { n.textContent = price; });
      var unlocked = 0;
      gifts.forEach(function (g) {
        var open = idx >= parseInt(g.getAttribute('data-unlock'), 10);
        g.classList.toggle('is-locked', !open);
        if (open) unlocked++;
      });
      buy.classList.toggle('has-2', unlocked >= 2);
      /* value row (USD only: the gift value is a USD figure): kit list price + unlocked gifts vs what you pay today */
      if (vrow) {
        var once = parseInt(p.getAttribute('data-once-c'), 10), sub = parseInt(p.getAttribute('data-sub-c'), 10), cmp = parseInt(p.getAttribute('data-cmp-c'), 10);
        var today = (m === 'sub' && sub) ? sub : once;
        var value = Math.max(cmp || once, once);
        if (cur === 'USD' && today && value > today) {
          $('[data-ero-v-value]', vrow).textContent = fmt(value);
          $('[data-ero-v-today]', vrow).textContent = fmt(today);
          $('[data-ero-v-save]', vrow).textContent = fmt(value - today);
          vrow.hidden = false;
        } else { vrow.hidden = true; }
      }
    }
    packs.forEach(function (p) { p.addEventListener('change', sync); });
    modes.forEach(function (m) { m.addEventListener('change', sync); });
    sync();

    var busy = false;
    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      if (!window.fetch) return;
      e.preventDefault();
      var p = selected();
      var idx = parseInt(p.getAttribute('data-idx'), 10) || 1;
      var item = { id: parseInt(p.value, 10), quantity: 1 };
      if (mode() === 'sub' && p.getAttribute('data-plan')) item.selling_plan = parseInt(p.getAttribute('data-plan'), 10);
      var items = [item];
      gifts.forEach(function (g) {
        if (idx >= parseInt(g.getAttribute('data-unlock'), 10) && g.getAttribute('data-variant')) {
          items.push({ id: parseInt(g.getAttribute('data-variant'), 10), quantity: 1, properties: { '_erozin_gift': 'yes' } });
        }
      });
      busy = true;
      btns.forEach(function (b) { b.disabled = true; var s = $('span', b); if (s) { b.setAttribute('data-keep', s.innerHTML); s.textContent = b.getAttribute('data-loading') || buy.getAttribute('data-loading') || ''; } });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          busy = false;
          btns.forEach(function (b) { b.disabled = false; var s = $('span', b); if (s && b.getAttribute('data-keep')) s.innerHTML = b.getAttribute('data-keep'); });
          form.submit();
        });
    });

    /* gallery */
    var track = $('[data-ero-track]', buy);
    var loadSlides = function () {
      $$('img[data-ero-src]', buy).forEach(function (im) {
        im.setAttribute('srcset', im.getAttribute('data-ero-srcset')); im.setAttribute('src', im.getAttribute('data-ero-src'));
        im.removeAttribute('data-ero-src'); im.removeAttribute('data-ero-srcset');
      });
    };
    if (track) {
      var go1 = function () { loadSlides(); };
      ['touchstart', 'pointerdown', 'wheel', 'focusin', 'keydown'].forEach(function (ev) { track.addEventListener(ev, go1, { once: true, passive: true }); });
      var later = function () { setTimeout(loadSlides, 1200); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    }
    if (track) {
      var dots = [], thumbs = $$('[data-ero-thumb]', buy), cnt = $('[data-ero-count]', buy);
      var mark = function (i) {
        if (cnt) cnt.textContent = String(i + 1);
        thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      };
      var go = function (i) { var w = track.clientWidth; track.scrollTo({ left: i * w, behavior: 'smooth' }); mark(i); };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-ero-dot'), 10)); }); });
      thumbs.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-ero-thumb'), 10)); }); });
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
      }, { passive: true });
    }

    /* sticky bar: visible once the buy box button has scrolled above the screen and until the final CTA is in view */
    var bar = $('[data-ero-sticky]');
    var mainBtn = $('[data-ero-cta]', form);
    var fin = $('[data-ero-final] [data-ero-cta]');
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      var zoneOut = false, finIn = false, scrolled = false, footIn = false;
      var upd = function () { bar.classList.toggle('is-on', scrolled && zoneOut && !finIn && !footIn); };
      var footEls = $$('.shopify-section-group-footer-group, footer'), footSeen = [];
      if (footEls.length) { var fio = new IntersectionObserver(function (en) { en.forEach(function (x) { var k = footEls.indexOf(x.target); footSeen[k] = x.isIntersecting; }); footIn = footSeen.some(Boolean); upd(); }, { threshold: 0 }); footEls.forEach(function (f) { fio.observe(f); }); }
      var onScroll = function () { var s = (window.scrollY || window.pageYOffset) > 300; if (s !== scrolled) { scrolled = s; upd(); } };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      new IntersectionObserver(function (en) { en.forEach(function (x) { zoneOut = !x.isIntersecting; upd(); }); }, { threshold: 0 }).observe(mainBtn);
      if (fin) new IntersectionObserver(function (en) { en.forEach(function (x) { finIn = x.isIntersecting; upd(); }); }, { threshold: 0.1 }).observe(fin);
    }
  }

  /* light motion: sections below the fold fade up as they scroll in (opacity + transform only, no layout shift; the buy box is never touched) */
  function tableFade() {
    $$('.ero-tbl--scroll .ero-tbl__scroll').forEach(function (el) {
      var chk = function () { el.classList.toggle('is-end', el.scrollWidth <= el.clientWidth + 2 || el.scrollLeft + el.clientWidth >= el.scrollWidth - 4); };
      el.addEventListener('scroll', chk, { passive: true }); chk(); window.addEventListener('resize', chk);
    });
  }

  function reveal() {
    if (!('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var sel = '[data-ero-section] .ero-eyebrow, [data-ero-section] .ero-h2, [data-ero-section] .ero-lead, [data-ero-section] .ero-lines span, [data-ero-section] .ero-list li, [data-ero-section] .ero-card, [data-ero-section] .ero-step, [data-ero-section] .ero-tcard, [data-ero-section] .ero-tbl__row, [data-ero-section] .ero-rev, [data-ero-section] .ero-callout, [data-ero-section] .ero-quote, [data-ero-section] .ero-media, [data-ero-section] .ero-formula__i, [data-ero-section] .ero-expert, [data-ero-section] .ero-seal, [data-ero-section] .ero-rt, [data-ero-section] .ero-details'
      + ', [data-ero-section] .ero-check, [data-ero-section] .ero-fail, [data-ero-section] .ero-stage__vis, [data-ero-section] .ero-stage__li, [data-ero-section] .ero-vs, [data-ero-section] .ero-statband li, [data-ero-section] .ero-ring, [data-ero-section] .ero-day, [data-ero-section] .ero-faq__card';
    var els = $$(sel);
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--i', Math.min(i, 5));
      el.classList.add('ero-rv');
      io.observe(el);
    });
    document.documentElement.classList.add('ero-js');
  }

  /* ---------- UX v2 (22-10): interactive pieces. Each one is complete without JS; JS only adds the play. ---------- */
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;

  /* stage stepper: tap a step = its picture + gauge position; plays through once while on screen, the first tap ends the play */
  function stages() {
    $$('[data-ero-stage]').forEach(function (root) {
      if (root.__ero) return; root.__ero = 1;
      var btns = $$('.ero-stage__step', root), imgs = $$('.ero-stage__img', root), pts = $$('.ero-curve__pt', root), run = $('.ero-gauge__run', root), grid = $('.ero-stage__grid', root);
      if (!btns.length) return;
      var cur = 0, timer = 0, playing = false, done = false, seen = false;
      var ms = parseInt(root.getAttribute('data-interval'), 10) || 4000;
      root.style.setProperty('--ero-int', ms + 'ms');
      var show = function (i) {
        cur = i;
        btns.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        pts.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        if (run) run.style.setProperty('--m', btns[i].getAttribute('data-m') || '0');
      };
      var stop = function () { clearTimeout(timer); playing = false; root.classList.remove('is-playing'); };
      var play = function () {
        clearTimeout(timer);
        if (!seen || done) { stop(); return; }
        playing = true; root.classList.add('is-playing');
        timer = setTimeout(function () {
          if (cur < btns.length - 1) { show(cur + 1); play(); } else { done = true; stop(); }
        }, ms);
      };
      var vis = $('.ero-stage__vis', root);
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          done = true; stop(); show(k);
          /* phones: keep the picture in view so the change is seen */
          if (vis && window.innerWidth < 990) { var r = vis.getBoundingClientRect(); if (r.top < 40 || r.top > window.innerHeight * 0.6) window.scrollBy({ top: r.top - 70, behavior: reduce ? 'auto' : 'smooth' }); }
        });
      });
      show(0);
      if (reduce || !root.hasAttribute('data-autoplay') || !hasIO || !grid) return;
      /* warm the other pictures so the crossfade never shows an empty frame */
      var warm = function () { imgs.forEach(function (im) { im.loading = 'eager'; }); };
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) warm(); }, { rootMargin: '600px 0px' }).observe(grid);
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { seen = x.isIntersecting; if (seen && !playing && !done) play(); else if (!seen && playing) stop(); });
      }, { threshold: 0.45 }).observe(grid);
    });
  }

  /* tap-what-fits check: toggles, counts, swaps the line under the list */
  function checks() {
    $$('[data-ero-check]').forEach(function (root) {
      if (root.__ero) return; root.__ero = 1;
      var items = $$('.ero-check__i', root), nEl = $('[data-ero-check-n]', root), msg = $('[data-ero-check-msg]', root), res = $('[data-ero-check-res]', root);
      if (!msg) return;
      var none = msg.textContent;
      items.forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          var n = items.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; }).length;
          if (nEl) nEl.textContent = String(n);
          if (res) res.classList.toggle('is-set', n > 0);
          var t = n === 0 ? none : (n === 1 ? (msg.getAttribute('data-one') || none) : (msg.getAttribute('data-many') || msg.getAttribute('data-one') || none));
          msg.textContent = t;
          if (res && !reduce) { res.classList.remove('is-set'); void res.offsetWidth; res.classList.toggle('is-set', n > 0); }
        });
      });
    });
  }

  /* numbers count up once on screen; the final text is in the HTML and is put back at the end */
  function counts() {
    var els = $$('[data-ero-count]');
    if (!els.length || reduce || !hasIO) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        io.unobserve(x.target);
        var el = x.target, txt = el.getAttribute('data-final');
        var m = /^(\D*)(\d[\d,]*(?:\.\d+)?)(.*)$/.exec(txt);
        if (!m) return;
        var pre = m[1], num = m[2], post = m[3], dec = (num.split('.')[1] || '').length, comma = num.indexOf(',') > -1, target = parseFloat(num.replace(/,/g, ''));
        var fmt = function (v) { var s = v.toFixed(dec); if (comma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return pre + s + post; };
        var t0 = 0, dur = 1400;
        var step = function (ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = p < 1 ? fmt(target * e) : txt;
          if (p < 1) requestAnimationFrame(step);
        };
        el.textContent = fmt(0);
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { el.setAttribute('data-final', el.textContent.trim()); io.observe(el); });
  }

  /* loops (ticker, final glow) stop off screen and while held */
  function loops() {
    $$('[data-ero-marquee]').forEach(function (root) {
      if (root.__ero) return; root.__ero = 1;
      root.addEventListener('touchstart', function () { root.classList.add('is-held'); }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (ev) { root.addEventListener(ev, function () { root.classList.remove('is-held'); }, { passive: true }); });
    });
    if (hasIO) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { x.target.classList.toggle('is-off', !x.isIntersecting); }); });
      $$('[data-ero-marquee], .ero-final').forEach(function (el) { io.observe(el); });
    }
    document.addEventListener('visibilitychange', function () { document.documentElement.classList.toggle('ero-hidden', document.hidden); });
  }

  /* reviews swipe on phones: the dots follow the scroll and jump to a review */
  function revs() {
    $$('[data-ero-revs]').forEach(function (track) {
      if (track.__ero) return; track.__ero = 1;
      var wrap = track.parentNode.querySelector('[data-ero-revdots]');
      if (!wrap) return;
      var dots = $$('.ero-revdot', wrap), cards = $$('.ero-rev', track);
      if (cards.length < 2) return;
      var stepW = function () { return cards[1].offsetLeft - cards[0].offsetLeft; };
      var mark = function () {
        var w = stepW() || 1, max = track.scrollWidth - track.clientWidth;
        var i = track.scrollLeft >= max - 4 ? cards.length - 1 : Math.round(track.scrollLeft / w);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      var raf = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * stepW(), behavior: reduce ? 'auto' : 'smooth' }); }); });
      mark();
    });
  }

  /* picture pins: pointing at a line in the key lights its number on the picture */
  function pins() {
    $$('.ero-media--pins').forEach(function (fig) {
      if (fig.__ero) return; fig.__ero = 1;
      var p = $$('.ero-pin', fig);
      $$('.ero-pinkey li', fig).forEach(function (li, k) {
        li.addEventListener('mouseenter', function () { if (p[k]) p[k].classList.add('is-hot'); });
        li.addEventListener('mouseleave', function () { if (p[k]) p[k].classList.remove('is-hot'); });
      });
    });
  }

  function ux2() { stages(); checks(); counts(); loops(); revs(); pins(); }

  /* v4 (im8 port): one named entrance per section on top of the port's light reveals (art director 22-10: 16-18px / 0.7s read as
     static). Compositor-only (opacity + the individual `translate` property, so it never fights a transform the port sets), one-shot,
     only for elements still below the fold at load (nothing visible pops), off under prefers-reduced-motion, never on price or the
     buy button. Stat numbers count up once. */
  function v4Motion() {
    if (!('IntersectionObserver' in window) || !Element.prototype.animate || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var groups = [
      ['[id$="__stages"] .im8-pt-slider__card', '-40px 0'],
      ['[id$="__how"] .im8-pt-slider__card', '0 40px'],
      ['[id$="__seed"] .im8-pt-slider__card', '0 40px'],
      ['[id$="__statistics"] .statistics-grid__column', '0 40px'],
      ['[id$="__advisory"] .im8-pro-sab__card', '0 40px'],
      ['[id$="__comparison"] .im8-cc__row', '0 24px']
    ];
    var vh = window.innerHeight || 800, vw = window.innerWidth || 400, groupsLeft = [];
    groups.forEach(function (g) {
      // below the fold AND inside the screen's width: a card waiting off to the side of a phone carousel is never touched, so it
      // can never be left hidden
      var els = $$(g[0]).filter(function (el) { var r = el.getBoundingClientRect(); return r.top > vh && r.left >= 0 && r.right <= vw + 1; });
      if (!els.length) return;
      els.forEach(function (el) { el.style.opacity = '0'; el.style.translate = g[1]; });
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          io.unobserve(x.target);
          var el = x.target, i = els.indexOf(el);
          var a = el.animate([{ opacity: 0, translate: g[1] }, { opacity: 1, translate: '0 0' }], { duration: 1000, delay: Math.min(i, 5) * 120, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
          a.onfinish = function () { el.style.opacity = ''; el.style.translate = ''; a.cancel(); };
        });
      }, { threshold: 0.01, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (el) { io.observe(el); });
      groupsLeft.push({ els: els, io: io });
    });
    // safety net: whatever has not played by the time the reader reaches the bottom is shown at once
    var bottom = function () {
      if ((window.scrollY || 0) + vh < document.documentElement.scrollHeight - 200) return;
      window.removeEventListener('scroll', bottom);
      groupsLeft.forEach(function (g) { g.els.forEach(function (el) { g.io.unobserve(el); el.style.opacity = ''; el.style.translate = ''; }); });
    };
    window.addEventListener('scroll', bottom, { passive: true });
    var nums = $$('[id$="__statistics"] .statistics-grid__stat h3');
    if (!nums.length) return;
    var cio = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        cio.unobserve(x.target);
        var h = x.target, txt = h.textContent, m = txt.match(/[\d][\d,.]*/);
        if (!m) return;
        var end = parseFloat(m[0].replace(/,/g, '')), comma = m[0].indexOf(',') > -1, t0 = null;
        var step = function (t) {
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / 1200), e = 1 - Math.pow(1 - k, 3), v = Math.round(end * e);
          h.textContent = txt.replace(m[0], comma ? v.toLocaleString('en-US') : String(v));
          if (k < 1) requestAnimationFrame(step); else h.textContent = txt;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (h) { cio.observe(h); });
  }

  /* v3: the house stage tabs (page6) swap a picture by setting img.src, but the <img> keeps its srcset, so the browser keeps showing
     stage 1 (ApexDrive never notices: its stages are videos). On each swap drop srcset/sizes and ask the CDN for a width that fits. */
  function tvhPosters() {
    var imgs = $$('img[data-tvh-poster]');
    if (!imgs.length || !('MutationObserver' in window)) return;
    var fix = function (im) {
      if (im.hasAttribute('srcset')) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); }
      var s = im.getAttribute('src') || '';
      var w = Math.min(2000, Math.max(400, Math.ceil((im.getBoundingClientRect().width || 500) * (window.devicePixelRatio || 1) / 200) * 200));
      if (/[?&]width=2000\b/.test(s) && w < 2000) im.setAttribute('src', s.replace(/([?&])width=2000\b/, '$1width=' + w));
    };
    var mo = new MutationObserver(function (list) { list.forEach(function (m) { fix(m.target); }); });
    imgs.forEach(function (im) { mo.observe(im, { attributes: true, attributeFilter: ['src'] }); });
  }

  /* BUY_MODE kaching (23-10): there is no #ero-form, so init() returned before wiring the sticky bar and the bar stayed hidden (art
     director 23-10). The buy box is im8's own product form that Kaching Bundles / Subscriptions attach to: the bar now shows once the
     page has scrolled and the form's button is off screen, and takes the shopper back to the buy box (the bundle widget holds pack +
     plan, so a blind add from the bar could skip them). Kaching Subscriptions also prints Liquid's escaped plan names
     ("Subscribe &amp; Save $10"): the entity is turned back into "&" inside Kaching's blocks, including after each re-render. */
  function nativeBuy() {
    if ($('#ero-form')) return;
    var atc = $('.ero-vx-native [data-vx-atc]');
    var anchor = $('#ero-buy');
    var bar = $('[data-ero-sticky]');
    if (bar && atc && anchor && 'IntersectionObserver' in window) {
      var btn = $('[data-ero-cta]', bar);
      if (btn) {
        btn.removeAttribute('form'); btn.type = 'button';
        btn.addEventListener('click', function (e) { e.preventDefault(); anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      }
      var out = false, scrolled = false, footIn = false, footSeen = [];
      var upd = function () { bar.classList.toggle('is-on', scrolled && out && !footIn); };
      var footEls = $$('.shopify-section-group-footer-group, footer');
      if (footEls.length) { var fio = new IntersectionObserver(function (en) { en.forEach(function (x) { footSeen[footEls.indexOf(x.target)] = x.isIntersecting; }); footIn = footSeen.some(Boolean); upd(); }, { threshold: 0 }); footEls.forEach(function (f) { fio.observe(f); }); }
      var onScroll = function () { var s = (window.scrollY || window.pageYOffset) > 300; if (s !== scrolled) { scrolled = s; upd(); } };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      new IntersectionObserver(function (en) { en.forEach(function (x) { out = !x.isIntersecting; upd(); }); }, { threshold: 0 }).observe(atc);
    }
    var fixAmp = function (root) {
      if (!root) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) if (n.nodeValue.indexOf('&amp;') > -1) n.nodeValue = n.nodeValue.replace(/&amp;/g, '&');
    };
    var watched = [];
    var sweep = function () {
      $$('kaching-subscriptions-block, kaching-bundle, kaching-bundles-block').forEach(function (el) {
        fixAmp(el); if (el.shadowRoot) fixAmp(el.shadowRoot);
        [el, el.shadowRoot].forEach(function (r) {
          if (!r || watched.indexOf(r) > -1 || !('MutationObserver' in window)) return;
          watched.push(r); new MutationObserver(function () { fixAmp(r); }).observe(r, { childList: true, subtree: true, characterData: true });
        });
      });
    };
    sweep(); var k = 0, t = setInterval(function () { sweep(); if (++k > 20) clearInterval(t); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); nativeBuy(); reveal(); tableFade(); ux2(); tvhPosters(); v4Motion(); }); else { init(); nativeBuy(); reveal(); tableFade(); ux2(); tvhPosters(); v4Motion(); }
})();
